module.exports = __webpack_public_path__ + "static/media/invoice_contract_help.ab2b8b5e.png";